import constants from '#packages/constants';

import type { EditorAPI } from '#packages/editorAPI';

function navigateTo(
  editorAPI: AnyFixMe,
  appData: AnyFixMe,
  token: AnyFixMe,
  options: AnyFixMe,
) {
  return new Promise<void>(function (resolve) {
    editorAPI.dsActions.platform.pages.navigateTo(options.pageUrl, function () {
      if (!editorAPI.preview.isInPreviewMode()) {
        editorAPI.preview.togglePreview(resolve, {
          biParams: { origin: constants.BI.PREVIEW.ORIGIN.PLATFORM },
        });
      } else {
        resolve();
      }
    });
  });
}

const togglePreview = (
  editorAPI: EditorAPI,
  options: { biParams: { origin: string } },
  callback?: Function,
) => {
  editorAPI.preview.togglePreview(callback, options);
};

export { navigateTo, togglePreview };
